export function never(value: never): never {
	void value;
	return undefined as never;
}
